import {
  Card,
  Descriptions,
  Space,
  Tag,
  Tooltip,
  Typography,
  message,
} from "antd";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { PROMO_TOOLTIPS } from "../../utils/constants";
import useApi from "../../utils/useApi";
import {
  formatarData,
  mensagemDeErro,
  podeEditarEvento,
  rotuloDaFamilia,
  rotuloDaMecanica,
  rotuloDaOrigem,
  rotuloDoEscopo,
  tagDaSituacao,
} from "./promoHelpers";

const { Text, Title } = Typography;

const LIMITE_DO_TITULO = 100;

export default function CabecalhoDoEvento({ evento, onTituloAlterado }) {
  const { user } = useAuth();
  const { patchEvent } = useApi();
  const queryClient = useQueryClient();
  const [messageApi, contextHolder] = message.useMessage();
  const [salvando, setSalvando] = useState(false);

  if (!evento) {
    return null;
  }

  const salvarTitulo = async (texto) => {
    const titulo = String(texto || "").trim();
    if (!titulo || titulo === evento.titulo) return;
    setSalvando(true);
    try {
      await patchEvent(evento.event_id, { title: titulo });
      onTituloAlterado?.(titulo);
      queryClient.invalidateQueries({ queryKey: ["eventsV2"] });
      messageApi.success("Título atualizado.");
    } catch (erro) {
      messageApi.error(
        mensagemDeErro(erro, "Não foi possível salvar o título.")
      );
    } finally {
      setSalvando(false);
    }
  };

  const escopo = rotuloDoEscopo(evento);
  const origem = rotuloDaOrigem(evento.origem);
  const situacao = tagDaSituacao(evento.situacao);
  const familia = rotuloDaFamilia(evento.familia);
  const mecanica = rotuloDaMecanica(evento.mechanic);
  const editavel = podeEditarEvento(user, evento) && !salvando;

  const itens = [
    {
      key: "inicio",
      label: "Início",
      children: formatarData(evento.datetime),
    },
    {
      key: "fim",
      label: "Fim",
      children: evento.end_datetime
        ? formatarData(evento.end_datetime)
        : "Sem data de fim",
    },
    ...(evento.escopo !== "produto" && evento.zona_nome
      ? [
          {
            key: "zonas",
            label: evento.n_zonas > 1 ? "Zonas" : "Zona",
            children: evento.zona_nome,
          },
        ]
      : []),
    {
      key: "comentario",
      label: "Comentário",
      children: evento.comentario || "—",
    },
  ];

  return (
    <Card style={{ width: "85%" }}>
      {contextHolder}
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Title
          level={3}
          style={{ margin: 0, textAlign: "left" }}
          editable={
            editavel
              ? {
                  onChange: salvarTitulo,
                  maxLength: LIMITE_DO_TITULO,
                  tooltip: "Editar título",
                  triggerType: ["icon"],
                }
              : false
          }>
          {evento.titulo}
        </Title>
        <Space wrap>
          <Tooltip title={PROMO_TOOLTIPS.escopo}>
            <Tag color={escopo.color}>{escopo.label}</Tag>
          </Tooltip>
          <Tag color={origem.color}>{origem.label}</Tag>
          {situacao && <Tag color={situacao.color}>{situacao.label}</Tag>}
          {familia && <Tag>{familia}</Tag>}
          {evento.codigo_erp && <Tag>Encarte #{evento.codigo_erp}</Tag>}
          {mecanica && <Tag>{mecanica}</Tag>}
          {evento.title_editado && (
            <Text type="secondary">Título editado na Ouran</Text>
          )}
        </Space>
        <Descriptions
          size="small"
          column={{ xs: 1, md: 2 }}
          items={itens}
          style={{ textAlign: "left" }}
        />
      </Space>
    </Card>
  );
}
